import React from "react";
import { Row, Col, Container, Card, CardBody, CardTitle } from "reactstrap";
import { useTranslation } from "react-i18next";
import StaticHeaderInfo from "components/pages/web/static/staticHeaderInfo";
import SimpleTable from "components/table/simpleTable";
import { TRADING_FEES, WITHDRAWAL_FEES } from "fixtureData/tableColumnsProprty";
import {
  TRADING_FEES_CONTENT,
  RIALS_FEES_CONTENT,
} from "fixtureData/tableRowsProperty";
import { getWithdrawFee } from "services/api";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { selectpriceTokens } from "store/selector/bestPriceCoins";
import { selectToken } from "store/selector/tokenStore";
import "assets/styles/components/card.scss";
import "assets/styles/components/lists.scss";
import { RIALS_FEES_COLUMNS } from "constants/tableColumns";
import { logoOptions } from "constants/lotties";
import LottieLogo from "components/pages/lottie";

export default function Fee() {
  const { t } = useTranslation();
  const { isLoading, isError, error, data, refetch } = useQuery(
    "getWithdrawFee",
    () => getWithdrawFee()
  );

  const dataTradeFee = React.useMemo(() => TRADING_FEES_CONTENT, []);
  const columnsTradeFee = React.useMemo(() => TRADING_FEES, []);
  const dataRialsFee = React.useMemo(() => RIALS_FEES_CONTENT, []);
  const columnsRialsFee = React.useMemo(() => RIALS_FEES_COLUMNS, []);
  const columnsWithdrawalFee = React.useMemo(() => WITHDRAWAL_FEES, []);
  const stateList = useSelector(selectpriceTokens);
  const { tokenList } = stateList;
  const { allTokens } = useSelector(selectToken);
  const listItems = [
    "Fees are deducted from both parties to the transaction.",
    "The transaction fee of the buyer of digital currency is paid on the basis of digital currency. (The commission amount will be deducted from the buyer's digital currency.)",
    "The transaction fee of the digital currency seller is paid based on Tomans. (The commission amount will be deducted from the seller's receipt.)",
    "The transaction fee amount will be displayed to you at the time of order registration.",
  ];
  const listRials = [
    "Deposit and payment in the form of Tomans, there is no fee.",
    "For Rial withdrawals, due to the use of online payment gateway and bank, 3000 Tomans will be deducted for each transaction.",
    "Permanent transfer to Ayandeh Bank is done more quickly.",
    "Fixed remittances are not made on holidays and non-working days.",
  ];
  const listWithdrawalFee = [
    "There is no fee for depositing digital currencies.",
    "The fee for withdrawing digital assets depends on the type of digital currency. This cost is deducted in proportion to the fees of the various blockchains.",
  ];
  const listTradeFee = [
    { title: "Loyalty level:", text: "Loyalty_Based" },
    { title: "Client:", text: "What_Client" },
    { title: "Customizable:", text: "What_Customizable" },
  ];
  return (
    <div>
      <StaticHeaderInfo>
        <div className="title-style  mb-5 mb-md-0">
          <span className="text-light fs-2 fw-bold ">
            {t("Fee in Coinnik market")}
          </span>
        </div>
      </StaticHeaderInfo>
      <Container>
        <Row className="my-3">
          <Col xs="12">
            <Card className="shadow  border-radius-1 py-2 none-padding mt-n5 mt-md-0">
              <CardBody className="text-secondary-two-light">
                <CardTitle className="pb-3 ">
                  <span className="pt-3 title-bordre-bottom">
                    {t("Trading fees in the Kevin Nick Market")}
                  </span>
                </CardTitle>
                <p className="text-secondary-two-light">{t("Trading_fees")}</p>
                <div className="list bullet-point ">
                  {listItems.map((item) => (
                    <Lists text={t(item)} />
                  ))}
                  <p className="text-secondary-two-light py-3">
                    {t(
                      "The commission for buying and selling digital currencies is calculated in steps according to the trading volume of the user in the last 30 days and is as follows:"
                    )}
                  </p>
                </div>
                <Row className="d-flex justify-content-center ">
                  <Col xs="9" className="d-none d-xl-block d-lg-block">
                    <Card className="shadow p-0 border-radius-1">
                      <SimpleTable
                        columns={columnsTradeFee}
                        data={dataTradeFee}
                      />
                    </Card>
                  </Col>
                </Row>
                <Row className="d-none d-xl-block d-lg-block py-5">
                  <Col xs="12">
                    <div>
                      {listTradeFee.map((item) => (
                        <p>
                          <span className="fw-medium text-secondary-two-light">
                            {t(item.title)}
                          </span>
                          <span className="text-secondary-two-light">
                            {t(item.text)}
                          </span>
                        </p>
                      ))}
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row className="d-block d-lg-none d-xl-none pb-3">
          <Col xs="12">
            <Card className="shadow p-0 border-radius-1">
              <SimpleTable columns={columnsTradeFee} data={dataTradeFee} />
            </Card>
          </Col>
        </Row>

        <Row>
          <Col xs="12">
            <Card className="shadow  border-radius-1 py-2 none-padding">
              <CardBody className="text-secondary-two-light">
                <CardTitle className="pb-3">
                  <span className="pt-3 title-bordre-bottom">
                    {t("Rial withdrawal fee")}
                  </span>
                </CardTitle>
                <div className="list bullet-point ">
                  {listRials.map((item) => (
                    <Lists text={t(item)} />
                  ))}
                  <p className="text-secondary-two-light py-3">
                    {t(
                      "Rial withdrawal is done by fixed transfer and at the hours announced by the Central Bank according to the following table:"
                    )}
                  </p>
                </div>
                <Row className="d-flex justify-content-center">
                  <Col xs="9" className="d-none d-xl-block d-lg-block">
                    <Card className="shadow p-0 border-radius-1 none-padding">
                      <SimpleTable
                        columns={columnsRialsFee}
                        data={dataRialsFee}
                      />
                    </Card>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row className="d-block d-lg-none d-xl-none pt-3">
          <Col xs="12">
            <Card className="shadow p-0 border-radius-1 ">
              <SimpleTable columns={columnsRialsFee} data={dataRialsFee} />
            </Card>
          </Col>
        </Row>

        <Row className="my-3">
          <Col xs="12">
            <Card className="shadow  border-radius-1 py-2 none-padding">
              <CardBody className="text-secondary-two-light">
                <CardTitle className="pb-2">
                  <span className=" pt-3 title-bordre-bottom">
                    {t("Digital currency deposit and withdrawal fee")}
                  </span>
                </CardTitle>
                <div className="list bullet-point ">
                  {listWithdrawalFee.map((item) => (
                    <Lists text={t(item)} />
                  ))}
                  <p className="text-secondary-two-light py-3">
                    {t(
                      "The fee for withdrawing digital assets from the Kevin Nick Market account depends on the type of coin and is calculated according to the table below."
                    )}
                  </p>
                </div>
                <Row className="d-flex justify-content-center">
                  <Col xs="9" className="d-none d-xl-block d-lg-block">
                    {data && tokenList.length && allTokens.length ? (
                      <Card className="shadow p-0 border-radius-1">
                        <SimpleTable
                          columns={columnsWithdrawalFee}
                          data={data}
                        />
                      </Card>
                    ) : (
                      <LottieLogo options={logoOptions} />
                    )}
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row className="d-block d-lg-none d-xl-none pt-3">
          <Col xs="12">
            <Card className="shadow p-0 border-radius-1 ">
              {data && tokenList.length && allTokens.length ? (
                <SimpleTable columns={columnsWithdrawalFee} data={data} />
              ) : null}
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

const Lists = ({ text }: any) => (
  <ul>
    <li>
      <span className="px-1">{text}</span>
    </li>
  </ul>
);
